import * as React from 'react'

export const IconSettings = () => (
  <svg width='24' height='24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M7.992 4.787c.504-.28.92-.71 1.102-1.257l.388-1.162A2 2 0 0 1 11.379 1h1.242a2 2 0 0 1 1.897 1.368l.388 1.162c.182.547.598.977 1.102 1.257.078.044.155.089.232.135.495.297 1.076.442 1.641.327l1.202-.246a2 2 0 0 1 2.133.96l.62 1.075a2 2 0 0 1-.235 2.327l-.815.919c-.382.43-.547 1.005-.538 1.58.002.09.002.181 0 .272-.009.575.156 1.15.538 1.58l.815.92a2 2 0 0 1 .236 2.326l-.621 1.076a2 2 0 0 1-2.133.96l-1.202-.247c-.565-.115-1.146.03-1.64.327a8.36 8.36 0 0 1-.233.135c-.504.28-.92.71-1.102 1.257l-.388 1.163A2 2 0 0 1 12.621 23h-1.242a2 2 0 0 1-1.897-1.367l-.388-1.163c-.182-.547-.598-.977-1.102-1.257a8.362 8.362 0 0 1-.232-.135c-.495-.297-1.076-.442-1.641-.327l-1.202.246a2 2 0 0 1-2.133-.96l-.62-1.075a2 2 0 0 1 .235-2.327l.815-.919c.382-.43.547-1.005.538-1.58a8.537 8.537 0 0 1 0-.272c.009-.575-.156-1.15-.538-1.58l-.815-.92a2 2 0 0 1-.236-2.326l.621-1.076a2 2 0 0 1 2.133-.96l1.202.247c.565.115 1.146-.03 1.64-.327a8.21 8.21 0 0 1 .233-.135Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z'
      fill='#EEE6EF'
    />
  </svg>
)
